if (!customElements.get('nwly-product-card')) {
  customElements.define('nwly-product-card', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = [...this.querySelectorAll('.nwly-pcard__slide')];
      this.index = 0;

      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse' && this.slides.length > 1) this.show(1);
      });
      this.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse') this.show(0);
      });
      this.addEventListener('click', async event => {
        const arrow = event.target.closest('[data-direction]');
        if (arrow) {
          this.show(this.index + Number(arrow.dataset.direction));
          return;
        }

        const size = event.target.closest('[data-variant-id]');
        if (!size || size.disabled || this.busy) return;
        const status = this.querySelector('[role="status"]');
        this.busy = true;
        this.setAttribute('aria-busy', 'true');
        status.textContent = status.dataset.adding;
        let update;
        try {
          const root = window.Shopify?.routes?.root || '/';
          const { CartLinesUpdateEvent } = await import('@shopify/events');
          update = CartLinesUpdateEvent.createPromise();
          const sectionIds = [...document.querySelectorAll('cart-items-component[data-section-id]')].map(item => item.dataset.sectionId);
          this.dispatchEvent(new CartLinesUpdateEvent({
            action: 'add', context: 'product',
            lines: [{ merchandiseId: size.dataset.variantId, quantity: 1 }],
            promise: update.promise
          }));
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: size.dataset.variantId, quantity: 1 }], sections: [...new Set(sectionIds)].join(',') })
          });
          const result = await response.json();
          const cartResponse = await fetch(root + 'cart.js');
          const cart = await cartResponse.json();
          update.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: { items: cart.items, source: 'nwly-product-card', sourceId: this.dataset.productId, productId: this.dataset.productId, itemCount: 1, sections: result.sections, didError: !response.ok }
          });
          if (!response.ok) throw new Error(result.description || status.dataset.error);
          status.textContent = status.dataset.added;
        } catch (error) {
          update?.reject(error);
          status.textContent = error.message || status.dataset.error;
        } finally {
          this.busy = false;
          this.removeAttribute('aria-busy');
        }
      });
    }

    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
    }
  });
}
